import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { faqs } from "../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-104" data-mp="1gcxsoqzdze2y">
      <div className="mx-auto max-w-2xl" data-id="element-105" data-mp="1gein8glpax0t">
        <h2 className="text-center font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-106" data-mp="2e066dzt5biue">
          Frequently asked <em className="text-plum-600" data-id="element-107" data-mp="292ehlensscuf">questions</em>
        </h2>

        <ul className="mt-10 divide-y divide-plum-100 border-y border-plum-100" data-id="element-108" data-mp="24208dtagmwut">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-109" data-mp="1z5jhirbvm4e1" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-bold text-ink focus:outline-none focus-visible:text-plum-700" data-id="element-110" data-mp="snmnmxb06xj0">
                  {f.q}
                  <PlusIcon className={`h-5 w-5 shrink-0 text-plum-600 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden data-id="element-111" data-mp="ueogm54nkte9" />
                </button>
                <AnimatePresence initial={false} data-id="element-112" data-mp="6r6na55qpn96">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-113" data-mp="biongqzxvjt3">
                      <p className="pb-5 text-[16px] leading-relaxed text-ink/70" data-id="element-114" data-mp="3k02vemlafy3s">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-115" data-mp="1pqe643dc69zz">
          <CtaButton label="I'm ready — give me access" data-id="element-116" data-mp="1ppclp8afkb5l" />
        </div>
      </div>
    </section>;
}